/**
 * When the end-of-reading rating appears (2026-10-20, SP-R1).
 *
 * Not as soon as the top panel's Summary tab is open: the chat is then still on
 * a card. It opens when the CHAT has reached the summary, meaning the summary
 * step has been delivered in the conversation.
 *
 * What the summary step delivers into the chat is the closing counsel: the card
 * the Mystic holds back (tarot-session-image tagged hold_until_summary) and
 * releases when the summary opens (revealSummaryHeldCards stamps it
 * _summaryDelivered). So the chat has reached the summary when the summary is
 * open AND, if the spread has a closing card, that card is in the chat. A
 * reading with no closing card has nothing else to deliver: the summary alone.
 * A reading reopened from history is finished already: at once.
 */
export function chatReachedSummary({ summarySeen, reopened, closingExpected, closingDelivered } = {}) {
  if (reopened) return true
  if (!summarySeen) return false
  return !closingExpected || !!closingDelivered
}
